<template>
  <div class="filter-wrap">
    <div class="filter-header">
      <div
        class="search-btn"
        @click="goSearch"
      >
        搜索门店名称或ID
      </div>
      <div
        v-for="(filterItem, filterIndex) in filterGroups"
        :key="filterIndex"
        class="filter-btn"
        :style="{ color: filterItem.tagKeyList && filterItem.tagKeyList.length ? '#FF5E00' : '' }"
        @click="onSwitchPopup(filterIndex)"
      >
        {{ `${filterItem.tagPartitionName}${filterItem.tagKeyList && filterItem.tagKeyList.length ? '·'+filterItem.tagKeyList.length+'' : ''}` }}
        <img
          v-if="!filterItem.active && (!filterItem.tagKeyList || filterItem.tagKeyList.length===0)"
          src="@/assets/img/arrow-circle-gray@2x.png"
        />
        <img
          v-if="!filterItem.active&&filterItem.tagKeyList && filterItem.tagKeyList.length>0"
          src="@/assets/img/arrow-down-circle-orange@2x.png"
        />
        <img
          v-if="filterItem.active"
          src="@/assets/img/arrow-up-circle-orange@2x.png"
        />
      </div>
      <div
        class="filter-btn"
        :style="{ color: indicatorFilter.tagKeyList && indicatorFilter.tagKeyList.length ? '#FF5E00' : '' }"
        @click="onSwitchIndicatorPopup()"
      >
        {{ `${indicatorFilter.tagPartitionName}${indicatorFilter.tagKeyList && indicatorFilter.tagKeyList.length ? '·'+(indicatorFilter.tagKeyList.filter(tag => String(tag).length === 1).length + (indicatorFilter.tagKeyList.some(tag => String(tag).length > 1) ? 1 : 0))+'' : ''}` }}
        <img
          v-if="!indicatorFilter.active && (!indicatorFilter.tagKeyList || indicatorFilter.tagKeyList.length===0)"
          src="@/assets/img/arrow-circle-gray@2x.png"
        />
        <img
          v-if="!indicatorFilter.active&&indicatorFilter.tagKeyList && indicatorFilter.tagKeyList.length>0"
          src="@/assets/img/arrow-down-circle-orange@2x.png"
        />
        <img
          v-if="indicatorFilter.active"
          src="@/assets/img/arrow-up-circle-orange@2x.png"
        />
      </div>
    </div>
    <van-popup
      v-for="(filterItem, filterIndex) in filterGroups"
      :key="filterIndex"
      v-model="filterItem.active"
      position="top"
      round
      class="filter-popup"
    >
      <div class="filter-popup__content">
        <div
          v-for="tagKey in Object.keys(filterItem.tagKeyMap)"
          :key="tagKey"
          class="tag-item"
          @click="onSelectTagKey(tagKey, filterIndex)"
        >
          <span>{{ filterItem.tagKeyMap[tagKey] }}</span>
          <img
            v-if="!filterItem.selectedTagKeyList.includes(tagKey)"
            src="@/assets/img/checkbox@2x.png"
          />
          <img
            v-else
            src="@/assets/img/checkbox-selected@2x.png"
          />
        </div>
      </div>
      <div class="filter-popup__footer">
        <span
          class="btn"
          style="border-right: 2px solid #eee;color: #666;"
          @click="filterGroups[filterIndex].active = false;"
        >
          取消
        </span>
        <span
          class="btn"
          style="color: #FF5E00;font-size: 600;"
          @click="onConfirmFilter(filterIndex)"
        >
          确定
        </span>
      </div>
    </van-popup>
    <van-popup
      v-model="indicatorFilter.active"
      position="top"
      round
      class="filter-popup"
    >
      <div class="filter-popup__content">
        <div
          v-for="tagKey in Object.keys(indicatorFilter.tagKeyMap)"
          :key="tagKey"
          class="tag-item"
          @click="onSelectIndicatorTagKey(tagKey)"
        >
          <span>{{ indicatorFilter.tagKeyMap[tagKey] }}</span>
          <img
            v-if="!indicatorFilter.selectedTagKeyList.includes(tagKey)"
            src="@/assets/img/checkbox@2x.png"
          />
          <img
            v-else
            src="@/assets/img/checkbox-selected@2x.png"
          />
        </div>
        <div
          class="tag-item"
          @click="onSelectIndicatorTagKey(3)"
        >
          <span>用户客诉</span>
          <img
            v-if="isCustComplaintSelect === 'none'"
            src="@/assets/img/checkbox@2x.png"
          />
          <img
            v-else-if="isCustComplaintSelect === 'any'"
            style="width: 4.8vw; margin-right:0.8vw;"
            src="@/assets/img/checkbox-indetermina.png"
          />
          <img
            v-else
            src="@/assets/img/checkbox-selected@2x.png"
          />
        </div>
        <div
          v-for="tagKey in Object.keys(indicatorFilter.custComplaintTagKeyMap)"
          :key="tagKey"
          class="tag-item children-tag-item"
          @click="onSelectIndicatorTagKey(tagKey)"
        >
          <span>{{ indicatorFilter.custComplaintTagKeyMap[tagKey] }}</span>
          <img
            v-if="!indicatorFilter.selectedTagKeyList.includes(tagKey)"
            src="@/assets/img/checkbox@2x.png"
          />
          <img
            v-else
            src="@/assets/img/checkbox-selected@2x.png"
          />
        </div>
      </div>
      <div class="filter-popup__footer">
        <span
          class="btn"
          style="border-right: 1px solid #eee;color: #666;"
          @click="indicatorFilter.active = false;"
        >
          取消
        </span>
        <span
          class="btn"
          style="color: #FF5E00;font-size: 500;"
          @click="onConfirmIndicatorFilter()"
        >
          确定
        </span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import tracker from '@/util/tracker';
import { BID } from '@/constants/statistics';

export default {
  name: 'SearchFilter',
  props: {
    filterGroups: {
      type: Array,
      default: () => [],
    },
    indicatorFilter: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      cid: this.$CID.ServiceLevelPoiList,
      isCustComplaintSelect: 'none', // 客诉选项选择情况，none表示未选择, all表示全选, any表示选择部分
    };
  },
  methods: {
    onSwitchPopup(filterIndex) {
      this.filterGroups.forEach((item, index) => {
        if (item.active) {
          item.active = false;
        } else if (index === filterIndex) {
          this.filterGroups[filterIndex].selectedTagKeyList = [...this.filterGroups[filterIndex].tagKeyList];
          item.active = true;
          tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_LIST_FILTER_LEVEL, null, { cid: this.cid });
        }
      });
      this.indicatorFilter.active = false;
    },
    onSwitchIndicatorPopup() {
      if (this.indicatorFilter.active) {
        this.indicatorFilter.active = false;
      } else {
        this.indicatorFilter.selectedTagKeyList = [...this.indicatorFilter.tagKeyList];
        this.handleSelectCustComplaint(this.indicatorFilter.selectedTagKeyList);
        this.indicatorFilter.active = true;
        tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_LIST_FILTER_INDICATOR, null, { cid: this.cid });
      }
      this.filterGroups.forEach((item) => {
        item.active = false;
      });
    },
    onSelectTagKey(tagKey, filterIndex) {
      const tagKeyList = this.filterGroups[filterIndex].selectedTagKeyList;
      const index = tagKeyList.indexOf(tagKey); // 查找 tagKeyIndex 的位置
      if (index !== -1) {
        tagKeyList.splice(index, 1); // 如果存在，移除该项
      } else {
        tagKeyList.push(tagKey); // 如果不存在，添加该项
      }
    },
    onSelectIndicatorTagKey(tagKey) {
      // debugger;
      let tagKeyList = JSON.parse(JSON.stringify(this.indicatorFilter.selectedTagKeyList));
      if (tagKey === 3) { // 如果选择的是用户客诉
        // 筛选出第一级的选项
        const indicatorSelectedTagKeyList = tagKeyList.filter((tag) => String(tag).length === 1);
        if (this.isCustComplaintSelect === 'all') {
          this.isCustComplaintSelect = 'none';
          tagKeyList = indicatorSelectedTagKeyList;
        } else {
          this.isCustComplaintSelect = 'all';
          tagKeyList = [
            ...indicatorSelectedTagKeyList,
            ...Object.keys(this.indicatorFilter.custComplaintTagKeyMap),
          ];
        }
      } else { // 如果选择的是其他选项
        const index = tagKeyList.indexOf(tagKey);
        if (index !== -1) {
          tagKeyList.splice(index, 1);
        } else {
          tagKeyList.push(tagKey);
        }
        if (String(tagKey).length > 1) { // 如果选了用户客诉子项，需要变更用户客诉选项的状态
          this.handleSelectCustComplaint(tagKeyList);
        }
      }
      this.indicatorFilter.selectedTagKeyList = tagKeyList;
    },
    handleSelectCustComplaint(tagKeyList) {
      const custComplaintKeys = Object.keys(this.indicatorFilter.custComplaintTagKeyMap);
      const selectedCustComplaintKeys = custComplaintKeys.filter((key) => tagKeyList.includes(key));
      if (selectedCustComplaintKeys.length === 0) {
        this.isCustComplaintSelect = 'none';
      } else if (selectedCustComplaintKeys.length === custComplaintKeys.length) {
        this.isCustComplaintSelect = 'all';
      } else {
        this.isCustComplaintSelect = 'any';
      }
    },
    onConfirmFilter(filterIndex) {
      this.filterGroups[filterIndex].tagKeyList = [...this.filterGroups[filterIndex].selectedTagKeyList];
      this.filterGroups[filterIndex].active = false;
      this.$emit('on-confirm-filter');
    },
    onConfirmIndicatorFilter() {
      this.indicatorFilter.tagKeyList = [...this.indicatorFilter.selectedTagKeyList];
      this.indicatorFilter.active = false;
      this.$emit('on-confirm-filter');
    },
    goSearch() {
      this.$router.push({
        name: 'ServiceLevelPoiListSearch',
        query: {
          serviceGradeFilter: this.filterGroups[0].tagKeyList,
          indicatorCodeFilter: this.indicatorFilter.tagKeyList,
        },
      });
      tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_LIST_SEARCH, null, { cid: this.cid });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-wrap {
  color: #222;
  font-family: "苹方-简";
  font-size: 0.28rem;
  .filter-header {
    display: flex;
    justify-content: space-between;
    height: 0.86rem;
    width: 100%;
    padding:0 0.24rem;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2147483647;
    .search-btn {
      display: flex;
      align-items: center;
      height: 0.56rem;
      margin: 0.12rem 0 0.18rem 0;
      border-radius: 0.84rem;
      padding: 0 0.24rem;
      font-size: 0.24rem;
      background-color: #f0f0f0;
      color: #999;
    }
    .filter-btn {
      margin: 0.2rem 0 0.26rem 0;
      height: 0.4rem;
      line-height: 0.4rem;
      display: flex;
      align-items: center;
      img {
        width: 0.24rem;
        margin-left: 0.07rem;
      }
    }
  }
  .van-popup--top {
    top: 0.86rem;
  }
  .van-popup--round {
    border-radius: 0 0 0.24rem 0.24rem;
  }
  .filter-popup {
    &__content {
      padding: 0.24rem 0.3rem;
      font-size: 0.28rem;
      .tag-item {
        height: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 0.48rem;
        }
      }
      .children-tag-item {
        padding-left:8vw;
      }
    }
    &__footer {
      border-top: 2px solid #eee;
      .btn {
        display: inline-block;
        width: 50%;
        height: 0.96rem;
        line-height: 0.96rem;
        font-size: 0.32rem;
        text-align: center;
      }
    }
  }
}
</style>
